import { FC } from "react";

interface SendIconSVGProps {
    className?: string;
}

const SendIconSVG: FC<SendIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.5515 17.4477C14.2967 17.1933 13.993 16.9932 13.6587 16.8594L3.0854 12.6194C2.95916 12.5687 2.85143 12.4807 2.77668 12.367C2.70193 12.2534 2.66373 12.1196 2.66721 11.9836C2.67069 11.8476 2.71569 11.716 2.79616 11.6063C2.87663 11.4966 2.98873 11.4142 3.1174 11.3701L28.4507 2.70339C28.5689 2.66072 28.6967 2.65258 28.8193 2.67992C28.9419 2.70725 29.0542 2.76894 29.143 2.85776C29.2319 2.94658 29.2935 3.05886 29.3209 3.18147C29.3482 3.30407 29.3401 3.43192 29.2974 3.55006L20.6307 28.8834C20.5866 29.0121 20.5042 29.1242 20.3945 29.2046C20.2848 29.2851 20.1532 29.3301 20.0172 29.3336C19.8812 29.3371 19.7474 29.2989 19.6338 29.2241C19.5201 29.1494 19.4321 29.0416 19.3814 28.9154L15.1414 18.3394C15.007 18.0054 14.8063 17.7021 14.5515 17.4477ZM14.5515 17.4477L29.1387 2.86339"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default SendIconSVG;
